import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { BreakingMarquee } from "./marquee";
import { newsByCategoryQuery } from "@/lib/site-queries";

const FALLBACK_HEADLINES = [
  "Argentina vs Egypt — Knockout clash headlines the weekend",
  "World Cup 2026 — 48 teams, 104 matches across North America",
  "Scaloni names provisional squad ahead of friendlies",
  "Messi reaches new milestone with the Albiceleste",
  "Primera División title race tightens into final stretch",
  "U20 side advances in continental qualifiers",
];

export function GlobalBreakingMarquee() {
  const { data } = useQuery({
    ...newsByCategoryQuery(undefined, 8),
    placeholderData: (prev) => prev,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const items = useMemo(() => {
    const live = (data ?? []).slice(0, 6).map((n) => n.title);
    return live.length > 0 ? live : FALLBACK_HEADLINES;
  }, [data]);

  return <BreakingMarquee items={items} />;
}
